export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativação de cheque eletrônico"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta de crédito"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Número"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Série"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Código de ativação"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ativar"])}
}